const routesNames = {
  calendar: "Calendar",
  calendarItem: "CalendarItem",
  collectionShow: "Collections.Show",
  walletShow: "Wallet.Show",
};

export default routesNames;